var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.53459 1H2.85603C2.19181 1 1.55479 1.26861 1.08511 1.74673C0.615431 2.22485 0.351569 2.87333 0.351569 3.54949V17.1468C0.350985 17.2965 0.389282 17.4438 0.462582 17.5736C0.535882 17.7035 0.641582 17.8113 0.768979 17.8861C0.895888 17.9607 1.03985 18 1.18639 18C1.33293 18 1.47689 17.9607 1.6038 17.8861L6.19531 15.1837L10.7868 17.8861C10.9141 17.9596 11.058 17.9977 11.2042 17.9966C11.3505 17.9977 11.4944 17.9596 11.6216 17.8861C11.749 17.8113 11.8547 17.7035 11.928 17.5736C12.0013 17.4438 12.0396 17.2965 12.0391 17.1468V3.54949C12.0391 2.87333 11.7752 2.22485 11.3055 1.74673C10.8358 1.26861 10.1988 1 9.53459 1ZM10.3694 15.6766L6.61272 13.467C6.48581 13.3924 6.34185 13.3532 6.19531 13.3532C6.04877 13.3532 5.90481 13.3924 5.7779 13.467L2.02121 15.6766V3.54949C2.02121 3.3241 2.10916 3.10795 2.26572 2.94857C2.42228 2.7892 2.63462 2.69966 2.85603 2.69966H9.53459C9.756 2.69966 9.96834 2.7892 10.1249 2.94857C10.2815 3.10795 10.3694 3.3241 10.3694 3.54949V15.6766Z",
    fill: "#BF1E2E",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddicon);
export default __webpack_public_path__ + "static/media/addicon.f89c64cde270c51a034d640fac0cb0b9.svg";
export { ForwardRef as ReactComponent };